'use client'

import {
  CmsContentContext,
  makeCmsHtmlContentHandler,
} from '@dxp/components/cms'
import { CmsContent, CmsKey, getCmsDefaults } from '@dxp/data-access'
import { useContext, useMemo } from 'react'

export const useCmsItemValue = (itemKey: CmsKey) => {
  const content = useContext(CmsContentContext)
  return useMemo(() => content[itemKey], [itemKey, content])
}

export function CmsContentProvider(
  props: React.PropsWithChildren<{ value: CmsContent }>,
) {
  const cmsContent = useMemo(() => {
    if (globalThis.DOMParser) {
      return new Proxy(
        props.value ?? getCmsDefaults(),
        makeCmsHtmlContentHandler(globalThis.DOMParser),
      )
    }

    return getCmsDefaults()
  }, [props.value])

  return <CmsContentContext.Provider {...props} value={cmsContent} />
}
